import { usePage } from '@inertiajs/react';


type TranslationProps = {
    translations: Record<string, any>;
    locale: string;
    isRtl: boolean;
    alternateUrls: Record<string, string>;
};

export default function useTranslations() {
    const pageProps = usePage<TranslationProps>().props;
    const { translations = {}, locale = 'en', isRtl = false, alternateUrls = {} } = pageProps;

    const __ = (key: string, replacements: Record<string, any> = {}): any => {
        const value = translations[key];

        if (value === undefined || value === null) {
            console.warn(`Translation not found for key: ${key}`);
            return key;
        }

        if (Array.isArray(value)) {
            return value;
        }

        if (typeof value === 'string') {
            return Object.entries(replacements).reduce(
                (str, [replaceKey, replaceVal]) => str.replace(`:${replaceKey}`, String(replaceVal)),
                value
            );
        }

        return value;
    };

    return {
        __,
        locale,
        isRtl,
        alternateUrls
    };
}
